import styled from 'styled-components';
import HomeIcon from '@mui/icons-material/Home';

export const Navbar =  styled.nav`
    display: flex;
    position: sticky;
    top: 0;
    justify-content: space-between ;
    width: 100%;
    height: 14vh;
    background-color: #fafbfc;
    padding: 8px;
    z-index: 99;
`;

export const Logo = styled.img`
    cursor: pointer;
    width : 20%;
   
    color: #FFF;
    object-fit: contain;
    font-size: 40px;
`;
export const Logos = styled.img`
    cursor: pointer;
    width : 75%;
    color: #FFF;
    object-fit: contain;
    font-size: 40px;
    margin-bottom: -1.5rem;
`;

export const DashNavbar = styled(Navbar)`
    background-color: #020528;
`;

export const LogoutButton = styled.button`
border: none;
color: #ff8901;
font-size: 1rem;
cursor: pointer;
background-color: #020528;

`;

export const ProfileContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
margin-right: 5rem;
`;

export const ProfileIcon = styled(HomeIcon)`
background-color: #fff;
margin-left: 0.7rem;
border-radius: 50%;
transform: scale(1.4);
color: #ff8901;
`




